import React from 'react';
import { translate } from '../../Services/translation';
import Popover from '../Popover/Popover';
import Icon from '../Icon';
import LanguageSelect from '../LanguageSelect';
import { useSelector } from 'react-redux';

const LanguageTrigger = ({ label }) => {
  return (
    <div className="header__button header__button--mobile-none">
      <Icon name="Globe" size={24} className="header__button-icon" />
      <span className="header__button-text">{label}</span>
    </div>
  );
};

const Language = () => {
  const channelPicker = useSelector((state) => state.site.channelPicker);

  return channelPicker ? (
    <Popover
      buttonContent={
        <LanguageTrigger label={channelPicker.currentChannel.name} />
      }
      id="language-picker-popover"
      panelAlignment="right"
    >
      <LanguageSelect />
    </Popover>
  ) : null;
};

export default Language;
